import { PageAccessByMenu } from './../interface/user';
import { SortDescriptor } from "@progress/kendo-data-query";
import { IconButtonActionType } from 'interface';
import { UserMenuItem } from "interface/userMenuItem";



export const sortGrid = (sorts: { fieldName: string, dir?: 'asc' | 'desc' }[]): SortDescriptor[] => {
    return sorts.map(item => ({
        field: item.fieldName,
        dir: item.dir || 'asc'
    }));
};


export const findMenuItemByPath = (menuItems: UserMenuItem[], pathname: string): UserMenuItem | undefined => {
  
  
  if(!menuItems || menuItems.length === 0 || !pathname){ 
    return undefined
  } 

  pathname = pathname.length===1 ? pathname + "/" : pathname.replace("/","")

  const findItem = (items: UserMenuItem[]): UserMenuItem | undefined => {
    for (const item of items) {
      if (item.path === pathname) {
        return item;
      }
      
      if (item.children && Array.isArray(item.children) && item.children.length > 0) {
        const foundInChildren = findItem(item.children);
         
        if (foundInChildren) {
          return foundInChildren;
        }
      }
    }
    
    return undefined;
  };
  
  return findItem(menuItems);
};

export const checkActionButton = (action: IconButtonActionType, pageAccess: PageAccessByMenu | null = null,): boolean => {
    if (!pageAccess) return false;
    switch (action) {
        case IconButtonActionType.Create:
            return pageAccess.create;
        case IconButtonActionType.Update:
            return pageAccess.update;
        case IconButtonActionType.Delete:
            return pageAccess.delete;
        // case IconButtonActionType.Confirm:
        //   return pageAccess.confirm;
        // case IconButtonActionType.Reject:
        //   return pageAccess.reject;
        // case IconButtonActionType.View:
        //   return pageAccess.view;
        default:
            return false;
    }
}

// /**
//  * Recursively converts object keys from PascalCase to camelCase.
//  * 
//  * @param {any} obj - The object to convert.
//  * @returns {any} - The object with camelCase keys.
//  */
// export const keysToCamel = (obj: any): any => {
//     if (isArray(obj)) {
//       return obj.map((value :any)=> keysToCamel(value));
//     } else if (isObject(obj)) {
//       return mapKeys(obj, (_value: any, key) => camelCase(key));
//     }
//     return obj;
//   };

  export function formatNorwegianNumber(
    num: number,
    mindDecimal: number = 0,
    maxDecimal: number = 0
  ) {
    if(num === null || num === undefined ){
      return ""
    }
    return num.toLocaleString("no-NO", {
      minimumFractionDigits: mindDecimal,
      maximumFractionDigits: maxDecimal,
    });
  }

